import React, { useState, useEffect } from "react";
import styles from "./AboutUs.module.css";
import { Link, useLocation } from "react-router-dom";

export default function AboutUs() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    // Jeśli w URL jest hash (np. /#gallery, /#contact)
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      // Jeśli nie ma hasha (np. po prostu /), przewiń na samą górę
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]); // uruchamia się za każdym razem, gdy zmienia się URL

  return (
    <section id="aboutUs" className="sectionContainer dark">
      <div className="sectionTitle">
        <h2>Poznaj nas i naszą ofertę</h2>
      </div>
      <div className={styles.aboutUsContent}>
        <h3>Tworzymy rozwiązania dopasowane do Twoich potrzeb</h3>
        <p className={styles.aboutUsDescribe}>
          Tworzymy nowoczesne strony internetowe oraz prowadzimy szkolenia
          informatyczne dla osób prywatnych, firm i instytucji. Każdą realizację
          opieramy na indywidualnym podejściu – projektujemy i kodujemy strony
          dopasowane do potrzeb klienta, a szkolenia przygotowujemy z
          uwzględnieniem poziomu wiedzy oraz oczekiwań uczestników. Stawiamy na
          praktyczne rozwiązania, przejrzystą komunikację i wysoką jakość
          wykonywanych usług.
        </p>
        <p className={`${styles.aboutUsDescribe} ${styles.aboutTraining}`}>
          Każdą stronę internetową projektujemy i kodujemy od podstaw, bez
          wykorzystania gotowych szablonów czy systemów CMS. Dzięki temu możemy
          tworzyć szybkie, bezpieczne i w pełni dopasowane do potrzeb klienta
          rozwiązania, które łatwo rozwijać wraz z rozwojem firmy.
        </p>
        <p className={`${styles.aboutUsDescribe} ${styles.aboutTraining}`}>
          Pomagamy również w wyborze i konfiguracji domeny, hostingu oraz
          certyfikatu SSL. Dbamy o podstawową optymalizację SEO, dzięki czemu
          strona jest odpowiednio przygotowana do indeksowania przez
          wyszukiwarki internetowe. W razie potrzeby przygotowujemy również
          podstawowe materiały graficzne dopasowane do charakteru działalności
          klienta.
        </p>

        <p className={`${styles.aboutUsDescribe} ${styles.aboutTraining}`}>
          Prowadzimy szkolenia informatyczne dla osób na różnych poziomach
          zaawansowania – od podstaw obsługi komputera po zagadnienia związane z
          nowoczesnymi technologiami. Organizujemy również szkolenia dla osób
          50+, pomagając im swobodnie korzystać z komputera, internetu i usług
          online. Stawiamy na niewielkie grupy, indywidualne podejście oraz
          praktyczną naukę dostosowaną do potrzeb uczestników.
        </p>
        <p className={styles.aboutUsDescribe}>
          <strong>
            Szczegółową ofertę szkoleń oraz informacje o poziomach zaawansowania
            znajdziesz w zakładce{" "}
            <Link
              to="/training"
              onClick={closeMenu}
              className={styles.linkAboutUs}
            >
              Szkolenia
            </Link>{" "}
            <br />
            Jeżeli interesuje Cię stworzenie nowoczesnej strony internetowej,
            zapraszamy również do zapoznania się z ofertą w zakładce{" "}
            <Link to="/web" onClick={closeMenu} className={styles.linkAboutUs}>
              Strony WWW
            </Link>
            .
          </strong>
        </p>
        {/* <p className={styles.aboutUsDescribe}>
          Poza projektowaniem cyfrowym zajmujemy się również sztuką. Na bazie
          własnych fotografii tworzymy obrazy, które następnie przenosimy na
          płótno dzięki czemu każdy projekt zyskuje wyjątkowy charakter.
        </p> */}
      </div>
      {/* <div className={styles.teamSection}>
        <div className={styles.teamLinkContainer}>
          <Link to="/team" onClick={closeMenu} className={styles.teamLink}>
            Poznaj nasz zespół
          </Link>
        </div>
      </div> */}
    </section>
  );
}
